import React from "react";

import styled from "styled-components";

const BackDrop = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 7000;
  left: 0;
  top: 0;
  background: #6262635e;
`;
const BackDrop2 = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 7000;
  left: 0;
  top: 0;
  background: #1E1E1E;
`;
const Backdrop = (props) =>
  props.show ? (
    props.admin ? (
      <BackDrop2 className="Backdrop" onClick={props.clicked}></BackDrop2>
    ) : (
      <BackDrop className="Backdrop" onClick={props.clicked}></BackDrop>
    )
  ) : null;

export default Backdrop;
